/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 278
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/fingerprint/Fingerprint/implementation/web)
 */

import * as amplitude from '@amplitude/analytics-browser'

export type Environment = 'production' | 'development'

export const ApiKey: Record<Environment, string> = {
  production: '88cf5b0af46a7ea03e4c55e329297106',
  development: '5dceeefed9db59d2104f53897fbab3d2',
}

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '278',
    branch: 'main',
    source: 'web',
    versionId: '7cd0b31e-a600-4a99-a60d-faa9a1043ef6',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
}

export interface LoadOptionsBase {
  disabled?: boolean
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment
  client?: { configuration?: BrowserOptions }
}
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions } }
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient } }

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance

export interface IdentifyProperties {
  '[Experiment] a-a-test'?: string
  Application?: string
  /**
   * Fingerprint's bot detection result.
   */
  botDetected?: string
  /**
   * True, if user has changed an account.
   *
   * False, if no account change occured.
   */
  changedAccounts?: boolean
  currentVisitorId?: string
  customer?: any
  customer_id?: any
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Self-Serve, Enterprise, Internal |
   */
  customerSegment?: 'Self-Serve' | 'Enterprise' | 'Internal'
  'fingerprint-device-id'?: any
  /**
   * Timestamp of user accoutn creation in Fingerprint Dashboard in **ISO 8601** format.
   */
  fingerprintUserAccountCreatedAt?: string
  /**
   * Set to False as early as user account is created, and to True, once API calls are recorded for the customer account.
   */
  hasFingerprintInstalled?: boolean
  initial_referrer?: string
  initial_referring_domain?: string
  initial_utm_campaign?: string
  initial_utm_content?: string
  initial_utm_id?: string
  initial_utm_medium?: string
  initial_utm_source?: string
  initial_utm_term?: string
  /**
   * * True, if a user's email contains @fingerprint.com or @fingerprintjs.com
   *
   * * False, if otherwise.
   */
  isInternal?: boolean
  'q3-2023-'?: string
  referrer?: string
  referring_domain?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  screenHeight?: number
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  screenWidth?: number
  subscription_id?: any
  taggedEventDetected?: boolean
  /**
   * True, if users leveraged Ask AI inside the Dashboard, false otherwise.
   */
  usedAppAskAI?: boolean
  /**
   * User role defining the permissions granted.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | readOnly, administrator, member, owner |
   */
  userRole?: 'readOnly' | 'administrator' | 'member' | 'owner'
  utm_campaign?: string
  utm_content?: string
  utm_device?: string
  utm_feeditemid?: string
  utm_id?: string
  utm_medium?: string
  utm_source?: string
  utm_term?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  viewportHeight?: number
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  viewportWidth?: number
  visitorId?: string
}

export interface GroupProperties {
  '[Amplitude] Group ID'?: any
  '[Amplitude] Group name'?: any
  /**
   * The name of the billing plan the subscription is associated with.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Fingerprint Pro, Fingerprint Pro Plus, Enterprise, Reverse Trial Freemium |
   */
  billingPlanName?: 'Fingerprint Pro' | 'Fingerprint Pro Plus' | 'Enterprise' | 'Reverse Trial Freemium'
  /**
   * A billing type, also referred to as a agreement type, defines the business relationship between customer and Fingerprint.
   *
   * `subscription.type` in MGMT-API is an application level property. Therefore, the values on the customer level must be derived based on data for all the applications under a given customer account. Values:
   *
   * * **Contract -** account that has at least one application on the Enterprise plan,
   *
   * * **Subscription** - account that has all applications on Pro or  Pro Plus plan,
   *
   * * **Trial** - account that has at least one application trialing,
   *
   * * **Other** - account that does not fall in any other buckets above (legacy plans)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Subscription, Contract, Trial, Other, POC, Freemium |
   */
  billingType?: 'Subscription' | 'Contract' | 'Trial' | 'Other' | 'POC' | 'Freemium'
  /**
   * True, if Sealed Results have been configured. False if otherwise.
   */
  sealedClientResults?: boolean
  /**
   * Unique identifier of the subscription.
   */
  subscriptionID?: string
  /**
   * Reason for using Fingerprint selected during the account creation flow.
   */
  useCase?: string
}

export interface GetDemoContactedProperties {
  /**
   * Property used for experimentation.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Control, Treatment |
   */
  variant?: 'Control' | 'Treatment'
  /**
   * Name of the variant that provides detailed information behind the experience. In case of doubt of what values to set in the context of a specific experiment, please consult the Product Analytics team.
   */
  variantName?: string
}

export interface NavItemClickedProperties {
  current_page_path: string
  nav_item_label: string
  nav_item_url: string
  nav_level: string
  nav_parent_label: string
}

export interface SalesContactedProperties {
  /**
   * Property used for experimentation.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Control, Treatment |
   */
  variant?: 'Control' | 'Treatment'
  /**
   * Name of the variant that provides detailed information behind the experience. In case of doubt of what values to set in the context of a specific experiment, please consult the Product Analytics team.
   */
  variantName?: string
}

export interface SignupOptionsShownProperties {
  /**
   * Name of the domain
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | fingerprint.com, dashboard.fingerprint.com |
   */
  domainName: 'fingerprint.com' | 'dashboard.fingerprint.com'
}

export interface SignupStartedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | password, google sso, github sso, microsoft sso |
   */
  signupType: 'password' | 'google sso' | 'github sso' | 'microsoft sso'
}

export interface TemplateWebCtaClickedProperties {
  /**
   * Name on a button on a marketing website.
   */
  ctaName: string
  template: string
}

export interface WebCtaClickedProperties {
  /**
   * Bot Detection Smart Signal
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  botDetected: string
  /**
   * Name on a button on a marketing website.
   */
  ctaName: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  'Web Page Path': string
}

export interface WebFormSubmittedProperties {
  /**
   * Bot Detection Smart Signal
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  botDetected: string
  /**
   * Name on a form / context for subimitting information
   */
  formName: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  'Web Page Path': string
}

export interface WebPageViewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  '[Amplitude] Page Counter'?: number
  /**
   * Bot Detection Smart Signal
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  botDetected: string
  /**
   * True, if signup options have been shown. By signup options we mean buttons that allow a user to click a button in order to start an account creation.
   *
   *
   *
   */
  signupOptionsShown: boolean
  /**
   * Virtual Machine Smart Signal. If Virtual Machine found, then True. Else False.
   */
  vmDetected: boolean
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  'Web Page Domain'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  'Web Page Location'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  'Web Page Path': string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  'Web Page Title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  'Web Page URL'?: string
}

export interface WebSalesCallScheduledProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  'Web Page Path': string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  'Web Page Title'?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  'Web Page URL'?: string
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY

  constructor(public event_properties?: IdentifyProperties) {
    this.event_properties = event_properties
  }
}

export class Group implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.GROUP_IDENTIFY

  constructor(public event_properties?: GroupProperties) {
    this.event_properties = event_properties
  }
}

export class DemoSuspectScoreClicked implements BaseEvent {
  event_type = 'Demo Suspect Score Clicked'
}

export class GetDemoContacted implements BaseEvent {
  event_type = 'Get Demo Contacted'

  constructor(public event_properties?: GetDemoContactedProperties) {
    this.event_properties = event_properties
  }
}

export class NavItemClicked implements BaseEvent {
  event_type = 'Nav Item Clicked'

  constructor(public event_properties: NavItemClickedProperties) {
    this.event_properties = event_properties
  }
}

export class RoiCalculatorFormSubmitted implements BaseEvent {
  event_type = 'ROI Calculator Form Submitted'
}

export class RoiCalculatorUsed implements BaseEvent {
  event_type = 'ROI Calculator Used'
}

export class SalesContacted implements BaseEvent {
  event_type = 'Sales Contacted'

  constructor(public event_properties?: SalesContactedProperties) {
    this.event_properties = event_properties
  }
}

export class SignupOptionsShown implements BaseEvent {
  event_type = 'Signup Options Shown'

  constructor(public event_properties: SignupOptionsShownProperties) {
    this.event_properties = event_properties
  }
}

export class SignupStarted implements BaseEvent {
  event_type = 'Signup Started'

  constructor(public event_properties: SignupStartedProperties) {
    this.event_properties = event_properties
  }
}

export class TemplateWebCtaClicked implements BaseEvent {
  event_type = 'Template Web CTA Clicked'

  constructor(public event_properties: TemplateWebCtaClickedProperties) {
    this.event_properties = event_properties
  }
}

export class WebCtaClicked implements BaseEvent {
  event_type = 'Web CTA Clicked'

  constructor(public event_properties: WebCtaClickedProperties) {
    this.event_properties = event_properties
  }
}

export class WebFormSubmitted implements BaseEvent {
  event_type = 'Web Form Submitted'

  constructor(public event_properties: WebFormSubmittedProperties) {
    this.event_properties = event_properties
  }
}

export class WebPageViewed implements BaseEvent {
  event_type = 'Web Page Viewed'

  constructor(public event_properties: WebPageViewedProperties) {
    this.event_properties = event_properties
  }
}

export class WebSalesCallScheduled implements BaseEvent {
  event_type = 'Web Sales Call Scheduled'

  constructor(public event_properties: WebSalesCallScheduledProperties) {
    this.event_properties = event_properties
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> }

const getVoidPromiseResult = () => ({ promise: Promise.resolve() })

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

  /**
   * Set Group for the current user
   *
   * @param groupType The group type.
   * @param groupName The group name.
   * @param options Optional event options.
   */
  setGroup(groupType: string, groupName: string | string[], options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.setGroup(groupType, groupName, options);
  }

  /**
   * Identify a group and set group properties.
   *
   * @param groupType The group type.
   * @param groupName The group name.
   * @param properties The group properties.
   * @param options Optional event options.
   */
  groupIdentify(
    groupType: string,
    groupName: string | string[],
    properties?: GroupProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.groupIdentify(groupType, groupName, amplitudeIdentify, options);
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Demo Suspect Score Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/Demo%20Suspect%20Score%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  demoSuspectScoreClicked(
    options?: EventOptions,
  ) {
    return this.track(new DemoSuspectScoreClicked(), options);
  }

  /**
   * Get Demo Contacted
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/Get%20Demo%20Contacted)
   *
   * **Description**: This event tracks the demo leads submitted via form available on a dedicated get demo page.
   *
   * **Triggering Conditions:** Click on submit button onSuccess for the <https://fingerprint.com/demo/#get-demo> page.
   *
   * Owner: Marwan Farha
   *
   * @param properties The event's properties (e.g. variant)
   * @param options Amplitude event options.
   */
  getDemoContacted(
    properties?: GetDemoContactedProperties,
    options?: EventOptions,
  ) {
    return this.track(new GetDemoContacted(properties), options);
  }

  /**
   * Nav Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/Nav%20Item%20Clicked)
   *
   * This event represents a user clicking on a navigation item on the website. It is triggered each time a navigation element is selected, enabling tracking of user interaction with the website.
   *
   * @param properties The event's properties (e.g. current_page_path)
   * @param options Amplitude event options.
   */
  navItemClicked(
    properties: NavItemClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NavItemClicked(properties), options);
  }

  /**
   * ROI Calculator Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/ROI%20Calculator%20Form%20Submitted)
   *
   * **Description**: Event indicating that a user has submitted a form ebedded as part of the ROI Calculator experience.
   *
   * **Triggering Condition:** button click, form submit on success
   *
   * Owner: Marwan Farha
   *
   * @param options Amplitude event options.
   */
  roiCalculatorFormSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new RoiCalculatorFormSubmitted(), options);
  }

  /**
   * ROI Calculator Used
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/ROI%20Calculator%20Used)
   *
   * **Description:** Triggered whenever a user uses the ROI calculator
   *
   * **Triggering Condition**: button click
   *
   * Owner: Marwan Farha
   *
   * @param options Amplitude event options.
   */
  roiCalculatorUsed(
    options?: EventOptions,
  ) {
    return this.track(new RoiCalculatorUsed(), options);
  }

  /**
   * Sales Contacted
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/Sales%20Contacted)
   *
   * **Description**: This event tracks the sales leads submitted via form available on a dedicated pricing page.
   *
   * **Triggering Condition:** Click on submit button onSuccess for the <https://fingerprint.com/contact-sales/> page.
   *
   * Owner: Marwan Farha
   *
   * @param properties The event's properties (e.g. variant)
   * @param options Amplitude event options.
   */
  salesContacted(
    properties?: SalesContactedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SalesContacted(properties), options);
  }

  /**
   * Signup Options Shown
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/Signup%20Options%20Shown)
   *
   * **Description**: Event to track when different signup options are displayed to users on either marketing websites (fingerprint.com) or dashboard (dashboard.fingerprint.com).
   *
   * **Triggering Conditions**: Page Load
   *
   * Owner: Marwan Farha
   *
   * @param properties The event's properties (e.g. domainName)
   * @param options Amplitude event options.
   */
  signupOptionsShown(
    properties: SignupOptionsShownProperties,
    options?: EventOptions,
  ) {
    return this.track(new SignupOptionsShown(properties), options);
  }

  /**
   * Signup Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/Signup%20Started)
   *
   * **Description**: This event tracks when a user begins the signup process on the platform.
   *
   * **Trigerring Condition**: Front-end event, button click, on CTAs like "Start Free with XYZ", or "Continue with XYZ"
   *
   * Owner: Marwan Farha
   *
   * @param properties The event's properties (e.g. signupType)
   * @param options Amplitude event options.
   */
  signupStarted(
    properties: SignupStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SignupStarted(properties), options);
  }

  /**
   * Template Web CTA Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/Template%20Web%20CTA%20Clicked)
   *
   * Triggers when a user selects any CTA on a recipes template page on our website. Indicating which CTA was selected via ctaName property, and which template they were looking at with the template property
   *
   * @param properties The event's properties (e.g. ctaName)
   * @param options Amplitude event options.
   */
  templateWebCtaClicked(
    properties: TemplateWebCtaClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TemplateWebCtaClicked(properties), options);
  }

  /**
   * Web CTA Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/Web%20CTA%20Clicked)
   *
   * Event indicating that a user clicked on the "Contact Sales" button
   *
   * Owner: Marwan Farha
   *
   * @param properties The event's properties (e.g. botDetected)
   * @param options Amplitude event options.
   */
  webCtaClicked(
    properties: WebCtaClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WebCtaClicked(properties), options);
  }

  /**
   * Web Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/Web%20Form%20Submitted)
   *
   * **Description:** Event indicating that a user has submitted a web form on the fingerprint.com pages
   *
   * **Trigerring Condition:** Form Submit on Success
   *
   * Owner: Marwan Farha
   *
   * @param properties The event's properties (e.g. botDetected)
   * @param options Amplitude event options.
   */
  webFormSubmitted(
    properties: WebFormSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WebFormSubmitted(properties), options);
  }

  /**
   * Web Page Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/Web%20Page%20Viewed)
   *
   * This event tracks when a web page is viewed, providing insights into user engagement and behavior on our marketing website on fingerprint.com domain.
   *
   * Owner: Marwan Farha
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Counter)
   * @param options Amplitude event options.
   */
  webPageViewed(
    properties: WebPageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WebPageViewed(properties), options);
  }

  /**
   * Web Sales Call Scheduled
   *
   * [View in Tracking Plan](https://data.amplitude.com/fingerprint/Fingerprint/events/main/latest/Web%20Sales%20Call%20Scheduled)
   *
   * **Description:** This event tracks when a sales call has been scheduled on fingerprint.com
   *
   * **Trigerring Condition:** Intro Call Booked on Success
   *
   * Owner: Marwan Farha
   *
   * @param properties The event's properties (e.g. Web Page Path)
   * @param options Amplitude event options.
   */
  webSalesCallScheduled(
    properties: WebSalesCallScheduledProperties,
    options?: EventOptions,
  ) {
    return this.track(new WebSalesCallScheduled(properties), options);
  }
}

export const ampli = new Ampli()

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions

export type BrowserClient = amplitude.Types.BrowserClient
export type BaseEvent = amplitude.Types.BaseEvent
export type IdentifyEvent = amplitude.Types.IdentifyEvent
export type GroupEvent = amplitude.Types.GroupIdentifyEvent
export type Event = amplitude.Types.Event
export type EventOptions = amplitude.Types.EventOptions
export type Result = amplitude.Types.Result
